/**
 * @desc 需求初审-更新收样时间
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.ProductConfirmAcceptRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productConfirm/updateAcceptTime`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
